import { z } from 'zod';

/**
 * Партнёрская программа: купленный пакет мест, каждое из которых партнёр
 * тратит на выдачу VIP другому человеку. Деньги ходят мимо продукта —
 * пакет заводит админ по факту офлайн-оплаты.
 */

/**
 * Размер пакета по умолчанию. Уже проданные пакеты хранят собственный снимок
 * в `VipPartnerPack.slotsTotal`: изменение константы не должно задним числом
 * менять объём того, что уже продано.
 */
export const VIP_PARTNER_PACK_SLOTS = 5;

/**
 * Срок VIP, выдаваемого партнёром. Изменение = деплой; уже выданные сроки
 * не двигаются, потому что каждая выдача хранит снимок `vipUntil`.
 */
export const VIP_PARTNER_VIP_MONTHS = 12;

export const CreateVipPartnerGrantInput = z.object({ recipientId: z.uuid() });
export type CreateVipPartnerGrantInput = z.infer<typeof CreateVipPartnerGrantInput>;

/** Краткая карточка получателя — только для показа в списке выдач. */
export const VipPartnerRecipientDto = z.object({
  id: z.uuid(),
  username: z.string().nullable(),
  firstName: z.string().nullable(),
});
export type VipPartnerRecipientDto = z.infer<typeof VipPartnerRecipientDto>;

export const VipPartnerGrantDto = z.object({
  id: z.uuid(),
  recipient: VipPartnerRecipientDto,
  vipUntil: z.iso.datetime(),
  grantedAt: z.iso.datetime(),
  revokedAt: z.iso.datetime().nullable(),
});
export type VipPartnerGrantDto = z.infer<typeof VipPartnerGrantDto>;

export const VipPartnerStateDto = z.object({
  slotsTotal: z.number().int().nonnegative(),
  slotsLeft: z.number().int().nonnegative(),
  grants: z.array(VipPartnerGrantDto),
});
export type VipPartnerStateDto = z.infer<typeof VipPartnerStateDto>;

/** Компактная форма для `/me`: фронту хватает остатка, чтобы решить судьбу кнопки. */
export const MeVipPartnerDto = z.object({
  slotsTotal: z.number().int().nonnegative(),
  slotsLeft: z.number().int().nonnegative(),
});
export type MeVipPartnerDto = z.infer<typeof MeVipPartnerDto>;

export const AdminCreateVipPartnerPackInput = z.object({
  slots: z.number().int().min(1).max(50).default(VIP_PARTNER_PACK_SLOTS),
  note: z.string().max(500).optional(),
});
export type AdminCreateVipPartnerPackInput = z.infer<typeof AdminCreateVipPartnerPackInput>;

export const AdminVipPartnerPackDto = z.object({
  id: z.uuid(),
  slotsTotal: z.number().int().nonnegative(),
  slotsLeft: z.number().int().nonnegative(),
  note: z.string().nullable(),
  grantedAt: z.iso.datetime(),
  revokedAt: z.iso.datetime().nullable(),
  grants: z.array(VipPartnerGrantDto),
});
export type AdminVipPartnerPackDto = z.infer<typeof AdminVipPartnerPackDto>;
